export interface DataAnalysisScores {
  insightExtraction: number;
  dataVisualization: number;
  decisionSupport: number;
}

export interface Question {
  id: number;
  text: string;
  options: {
    text: string;
    scores: DataAnalysisScores;
  }[];
}

export const questions: Question[] = [
  {
    id: 1,
    text: "How do you currently analyze your business data?",
    options: [
      {
        text: "Manually reviewing spreadsheets and reports",
        scores: { insightExtraction: 3, dataVisualization: 3, decisionSupport: 2 },
      },
      {
        text: "Basic charts and graphs in Excel",
        scores: { insightExtraction: 2, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "Business intelligence tools with some automation",
        scores: { insightExtraction: 1, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "AI-powered analytics with automated insights",
        scores: { insightExtraction: 0, dataVisualization: 1, decisionSupport: 1 },
      },
    ],
  },
  {
    id: 2,
    text: "What's your biggest challenge with understanding your data?",
    options: [
      {
        text: "Too much data, not enough time to analyze it",
        scores: { insightExtraction: 3, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "Hard to spot trends and patterns",
        scores: { insightExtraction: 2, dataVisualization: 3, decisionSupport: 2 },
      },
      {
        text: "Difficulty translating data into actions",
        scores: { insightExtraction: 2, dataVisualization: 1, decisionSupport: 3 },
      },
      {
        text: "Data is scattered across multiple sources",
        scores: { insightExtraction: 2, dataVisualization: 2, decisionSupport: 2 },
      },
    ],
  },
  {
    id: 3,
    text: "How quickly can you answer important business questions with data?",
    options: [
      {
        text: "Days to weeks - need to compile and analyze manually",
        scores: { insightExtraction: 3, dataVisualization: 2, decisionSupport: 3 },
      },
      {
        text: "Several hours with current tools",
        scores: { insightExtraction: 2, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "About an hour with some preparation",
        scores: { insightExtraction: 1, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "Instantly through AI-powered dashboards",
        scores: { insightExtraction: 0, dataVisualization: 1, decisionSupport: 1 },
      },
    ],
  },
  {
    id: 4,
    text: "How do you currently visualize your business metrics?",
    options: [
      {
        text: "Static reports and spreadsheet tables",
        scores: { insightExtraction: 2, dataVisualization: 3, decisionSupport: 2 },
      },
      {
        text: "Basic charts updated manually",
        scores: { insightExtraction: 1, dataVisualization: 3, decisionSupport: 1 },
      },
      {
        text: "Interactive dashboards but hard to customize",
        scores: { insightExtraction: 1, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "AI-generated visualizations that auto-update",
        scores: { insightExtraction: 0, dataVisualization: 1, decisionSupport: 1 },
      },
    ],
  },
  {
    id: 5,
    text: "How confident are you in data-driven decisions?",
    options: [
      {
        text: "Often rely on gut feeling due to lack of clear insights",
        scores: { insightExtraction: 2, dataVisualization: 2, decisionSupport: 3 },
      },
      {
        text: "Use data when available but it's often incomplete",
        scores: { insightExtraction: 2, dataVisualization: 1, decisionSupport: 3 },
      },
      {
        text: "Fairly confident but analysis takes too long",
        scores: { insightExtraction: 1, dataVisualization: 1, decisionSupport: 2 },
      },
      {
        text: "Very confident with AI-powered recommendations",
        scores: { insightExtraction: 0, dataVisualization: 1, decisionSupport: 1 },
      },
    ],
  },
  {
    id: 6,
    text: "How do you identify anomalies or unusual patterns in your data?",
    options: [
      {
        text: "We usually don't notice until it's a big problem",
        scores: { insightExtraction: 3, dataVisualization: 2, decisionSupport: 3 },
      },
      {
        text: "Manual review when we have time",
        scores: { insightExtraction: 2, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "Set alerts for specific thresholds",
        scores: { insightExtraction: 1, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "AI automatically detects and alerts on anomalies",
        scores: { insightExtraction: 0, dataVisualization: 1, decisionSupport: 1 },
      },
    ],
  },
  {
    id: 7,
    text: "How do you share insights with your team?",
    options: [
      {
        text: "Email screenshots and spreadsheets",
        scores: { insightExtraction: 2, dataVisualization: 3, decisionSupport: 2 },
      },
      {
        text: "Shared documents and periodic reports",
        scores: { insightExtraction: 1, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "Shared dashboards but not interactive",
        scores: { insightExtraction: 1, dataVisualization: 2, decisionSupport: 2 },
      },
      {
        text: "Real-time collaborative analytics platform",
        scores: { insightExtraction: 0, dataVisualization: 1, decisionSupport: 1 },
      },
    ],
  },
];
